import { Import } from "@fusion-advantage/backcompat"

export const draftImportApplyPrevImport = (nextImp: Import, prevImp: Import): Import => {
	let nextCalcErr = nextImp.FormResponse.CalculationEngineErrors
	const prevCalcErr = prevImp.FormResponse.CalculationEngineErrors
	if(prevCalcErr && prevCalcErr.length > 0) {
		nextCalcErr = [
			...prevCalcErr,
			...(nextCalcErr ?? []),
		]
	}
	return {
		FormResponse: {
			Encounter: nextImp.FormResponse.Encounter,
			ConceptStatuses: nextImp.FormResponse.ConceptStatuses,
			StatusHistory: [
				...nextImp.FormResponse.StatusHistory,
				...prevImp.FormResponse.StatusHistory,
			],
			CalculationEngineErrors: nextCalcErr,
		},
	}
}
